export const SCROLL_AREA_AXES = ['vertical', 'horizontal', 'both'] as const;
export type SScrollAreaAxis = (typeof SCROLL_AREA_AXES)[number];
